import { ReactNode } from "react";
import { Paper } from "@mantine/core";
import {
  CONTROL_BUTTON_SETTINGS,
  CONTROL_BUTTON_SHADOW,
} from "config/constants";

export const MapControlPaper = ({ children }: { children: ReactNode }) => (
  <Paper
    style={{
      boxShadow: CONTROL_BUTTON_SHADOW,
      fontSize: CONTROL_BUTTON_SETTINGS.iconFontSize,
      minWidth: CONTROL_BUTTON_SETTINGS.size,
      minHeight: CONTROL_BUTTON_SETTINGS.size,
    }}
    shadow="xs"
  >
    {children}
  </Paper>
);
